/*
 * Handy-Menü (sections/kik-mnav.liquid). Impact öffnet seine Menü-Schublade über einen Klick-Listener für
 * [aria-controls="header-sidebar-menu"]. Dieser Listener läuft vorher (Capture-Phase an document), hält den Klick an
 * und öffnet stattdessen das kik-Menü als <dialog>. Nur unter 1000 px, darüber bleibt alles bei Impact.
 * Elemente mit data-kik-mnav-close schließen das Menü. Das Suchfeld trägt zusätzlich aria-controls="search-drawer",
 * der Klick läuft danach weiter zu Impact und öffnet die Such-Schublade.
 */
(() => {
  const dialog = document.getElementById('kik-mnav');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  const mobil = window.matchMedia('(max-width: 999px)');
  let ausloeser = null;

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[aria-controls="header-sidebar-menu"]');
    if (!button || !mobil.matches || dialog.contains(button)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    ausloeser = button;
    dialog.showModal();
    button.setAttribute('aria-expanded', 'true');
  }, true);

  dialog.addEventListener('click', (event) => {
    // Klick auf den abgedunkelten Hintergrund (außerhalb des Panels) trifft das <dialog> selbst
    if (event.target === dialog || event.target.closest('[data-kik-mnav-close]')) {
      dialog.close();
    }
  });

  dialog.addEventListener('close', () => {
    if (ausloeser) ausloeser.setAttribute('aria-expanded', 'false');
  });

  mobil.addEventListener('change', (event) => {
    if (!event.matches && dialog.open) dialog.close();
  });
})();
